import { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';

export default function FlexItem({ children, ...rest }) {
  const Child = Children.only(children);
  const style = { ...rest, ...Child.props.style };
  return cloneElement(Child, { style });
}

export const propTypes = {
  children: PropTypes.node.isRequired,
  alignSelf: PropTypes.oneOf(['auto', 'flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  flexGrow: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.oneOf(['initial', 'inherit']),
  ]),
  flexShrink: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.oneOf(['initial', 'inherit']),
  ]),
  flexBasis: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  order: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

FlexItem.propTypes = propTypes;
FlexItem.defaultProps = {
  alignSelf: 'auto',
  flexBasis: 'auto',
  flexGrow: 0,
  flexShrink: 1,
  order: 0,
};
